import { WebReportEvent, JsErrorReport } from '@slardar/sdk-web';
import BasePlugin from './base-plugin';

type ThirdLib = 'garfish' | 'jupiter' | 'cookieBanner';
const thirdLibErrorMap: Record<ThirdLib, string[]> = {
  garfish: ['@garfish', '[Garfish warning]'],
  jupiter: ['jupiter'],
  cookieBanner: ['tiktok-cookie-banner'],
};
const isInnerThirdLibError = (event: JsErrorReport): boolean | string => {
  const stack = event.payload.error?.stack ?? '';
  const message = event.payload.error.message ?? '';
  for (const lib in thirdLibErrorMap) {
    if (
      thirdLibErrorMap[lib as ThirdLib].some(
        error => stack.includes(error) || message.includes(error),
      )
    ) {
      return lib;
    }
  }
  return false;
};
export default class ThirdLibErrorPlugin extends BasePlugin {
  handle(event: JsErrorReport) {
    const { payload } = event;
    const { error } = payload;
    const thirdLibName = isInnerThirdLibError(event);
    if (thirdLibName) {
      // modify js_error level to warn
      payload.extra = {
        ...payload.extra,
        level: 'warn',
      };
      // modify error name
      if (error.name && !error.name?.startsWith('[')) {
        error.name = `[warn][ThirdLibError] - ${thirdLibName as string} - ${
          error.name
        }`;
      }
    }
    return event;
  }

  shouldHandle(event: WebReportEvent): event is JsErrorReport {
    return event.ev_type === 'js_error' && Boolean(isInnerThirdLibError(event));
  }
}
